module.exports = function () { /* empty */ };



//////////////////
// WEBPACK FOOTER
// C:/Users/Administrator/Desktop/sailing-work/mapbox/mapboxProject/node_modules/_core-js@2.6.9@core-js/library/modules/_add-to-unscopables.js
// module id = WkkM
// module chunks = 1